import { colors } from "@/utils/const";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import OutImgSection from "../out-img-section";
import CustomText from "../text";
import { useI18n } from "@/i18n/I18nProvider";

export default function SplitPgSection({
  img,
  title,
  titleType = "h2",
  paragraph,
  paragraphType = "body1",
  note,
  bgHeight = { xs: "70%", md: "40%" },
  withBg = true,
  pgBg,
  id,
}) {
  const { locale } = useI18n();
  const isArabic = locale === "ar";

  return (
    <Box
      id={id}
      component="section"
      className="horizontal-safe-padding vertical-safe-padding"
      sx={{
        position: "relative",
        overflow: "hidden",
        bgcolor: "transparent",
        "&::before": {
          content: '""',
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          height: !withBg ? "auto" : bgHeight,
          backgroundColor: !withBg ? "#fff" : colors.navy,
          zIndex: 0,
        },
      }}
    >
      <Grid
        container
        spacing={{ xs: 4, md: 0 }}
        alignItems="center"
        sx={{
          flexDirection: {
            xs: "column-reverse",
            md: "row",
          },
          position: "relative",
          zIndex: 1,
        }}
      >
        <Grid item xs={12} md={6}>
          <>
            <CustomText
              text={title}
              type="xxl"
              customStyle={{
                color: !withBg ? colors.orange : colors.dark_yellow,
                fontWeight: "700",
                lineHeight: 1,
                my: { xs: 2, md: 1 },
              }}
              variant={titleType || "h2"}
            />
            <CustomText
              text={paragraph}
              type="xxs"
              customStyle={{
                color: { xs: "#fff", md: "#000" },
                pt: 2,
                lineHeight: 1.5,
                ...pgBg,
              }}
              variant={paragraphType}
              enableHtml={true}
            />
          </>

          {note && (
            <CustomText
              text={note}
              type="xxs"
              customStyle={{
                color: "#000",
                pt: 3,
                fontWeight: "700",
              }}
              variant="caption"
            />
          )}
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: {
              xs: "center",
              md: isArabic ? "flex-start" : "flex-end",
            },
          }}
        >
          <OutImgSection
            img={img}
            altImg={title}
            side={isArabic ? "left" : "right"}
            customStyle={{
              width: { xs: "100%", xl: "65%" },
              transform: {
                lg: isArabic ? "translateX(-18%)" : "translateX(18%) ",
                xl: isArabic ? "translateX(0%)" : "translateX(0%)",
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
